import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsUUID,
  IsOptional,
  IsDateString,
  IsArray,
  ArrayNotEmpty,
  Matches,
} from 'class-validator'

export class BulkAssignClassDto {
  @ApiProperty({
    description: "UUID de l'activité à assigner",
  })
  @IsUUID()
  activityId!: string

  @ApiProperty({
    description: 'Liste des IDs de classes',
    type: [String],
  })
  @IsArray()
  @ArrayNotEmpty()
  @IsUUID(undefined, { each: true })
  classIds!: string[]

  @ApiPropertyOptional({
    description: 'Année académique (format: YYYY-YYYY)',
    example: '2024-2025',
  })
  @IsOptional()
  @Matches(/^\d{4}-\d{4}$/)
  academicYear?: string

  @ApiPropertyOptional({
    description: 'Date de disponibilité (ISO 8601)',
    example: '2024-11-01T00:00:00Z',
  })
  @IsOptional()
  @IsDateString()
  availableFrom?: string

  @ApiPropertyOptional({
    description: "Date d'échéance (ISO 8601)",
    example: '2024-11-30T23:59:59Z',
  })
  @IsOptional()
  @IsDateString()
  dueAt?: string
}

